import { snapfishActionTypes } from '../actions/snapfish-action-types';
import { getMapFromIdObjectArray, removeItemFromSetAndCreateNewWithId } from '../../common/reducer-helpers';

const initialSnapfishState = {
	snapfishCollections: new Map(),
	snapfishCollectionOffset: 0,
	snapfishCollectionCount: 0,
	snapfishCollectionMax: 25,
	snapfishAlbums: new Map(),
	snapfishPhotoElements: new Map(),
	snapfishSelectedElements: new Set(),
	snapfishSelectedUUID: '',
	currentAlbumId: -1,
	currentAlbumCount: -1,
	currentAlbumMax: 25,
	currentAlbumOffset: 0,
	viewMode: 'album',
	amIfetchingItems: false,
	amdIfetchingAlbums: false,
	isCompleteItems: false,
	isCompleteAlbums: false
};

export const snapfish = (state = initialSnapfishState, action) => {
	switch (action.type) {
		case snapfishActionTypes.SNAPFISH_PHOTO_ELEMENTS_REQUEST:
			return {
				...state,
				amIfetchingItems: true
			};
		
			case snapfishActionTypes.SNAPFISH_CUSTOM_COLLECTION_REQUEST:
			return {
				...state,
				amdIfetchingAlbums: true
			};


			
		case snapfishActionTypes.SNAPFISH_CUSTOM_COLLECTION_SUCCESS:
			return {
				...state,
				snapfishCollections: new Map([
					...state.snapfishCollections.entries(),
					...getMapFromIdObjectArray(action.collections)
				]),
				snapfishCollectionOffset: action.offset + action.max,
				snapfishCollectionCount: action.count,
				snapfishCollectionMax: action.max,
				amdIfetchingAlbums: false,
				isCompleteAlbums: action.isCompleteAlbums
			};
		case snapfishActionTypes.SNAPFISH_PHOTO_ELEMENTS_SUCCESS:
		if(state.currentAlbumId !== action.ccId){
			return {
				...state
			};
		}
		else {
			return {
				...state,
				// currentAlbumId: action.ccId,
				currentAlbumCount: action.count,
				currentAlbumMax: action.max,
				currentAlbumOffset: action.offset + action.max,
				snapfishPhotoElements: new Map([
					...state.snapfishPhotoElements.entries(),
					...getMapFromIdObjectArray(action.elements)
				]),
				amIfetchingItems: false,
				isCompleteItems: action.isCompleteItems
			};
		}
			case snapfishActionTypes.SNAPFISH_PHOTO_ELEMENTS_FAILURE:
			return {
				...state,
				amIfetchingItems: false
			};
			case snapfishActionTypes.SNAPFISH_CUSTOM_COLLECTION_FAILURE:
			return {
				...state,
				amdIfetchingAlbums: false
			};

		case snapfishActionTypes.SNAPFISH_RETRIEVE_SELECTED_PHOTOS_SUCCESS:
			return state;
		case snapfishActionTypes.SNAPFISH_CLEAR_PHOTO_ELEMENTS:
			return {
				...state,
				snapfishPhotoElements: new Map(),
				currentAlbumId: -1,
				isCompleteItems: false,
				amIfetchingItems: false
			};
		case snapfishActionTypes.SNAPFISH_CLEAR_SELECTED_PHOTOS:
			return {
				...state,
				snapfishSelectedElements: new Set()
			};
		case snapfishActionTypes.SNAPFISH_SELECT_ITEM:
			return {
				...state,
				snapfishSelectedElements: new Set([...state.snapfishSelectedElements.values(), action.id])
			};
		case snapfishActionTypes.SNAPFISH_SET_CURRENT_ALBUM_ID:
			return {
				...state,
				currentAlbumId: action.id,
				currentAlbumOffset: 0
			};
		case snapfishActionTypes.SNAPFISH_DESELECT_ITEM:

			return {
				...state,
				snapfishSelectedElements: removeItemFromSetAndCreateNewWithId(state.snapfishSelectedElements, action.id)
			};
		case snapfishActionTypes.SNAPFISH_SAVE_SELECTION_SUCCESS:
			return {
				...state,
				snapfishSelectedUUID: action.uuid
			};
		case snapfishActionTypes.SNAPFISH_SET_ALBUM_VIEW_MODE:
			return {
				...state,
				viewMode: 'album',
				currentAlbumId: -1,
				snapfishPhotoElements: new Map(),
				isCompleteItems: false,
				amIfetchingItems: false
			};
		case snapfishActionTypes.SNAPFISH_SET_UPLOAD_VIEW_MODE:
			return {
				...state,
				viewMode: 'upload',
				currentAlbumId: -1,
				snapfishPhotoElements: new Map(),
				isCompleteItems: false,
				amIfetchingItems: false
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/snapfish/reducers/snapfish-reducer.js